module.exports = __webpack_public_path__ + "cbd72f293cf5ab38e2c96b2a1e90463d.svg";